import React from 'react'
import { isMobile, isTablet } from "react-device-detect";
import PropTypes from 'prop-types';

const Video = props => {

    const { urlEspecialVideos, slug, type } = props;
    var width = '100%';
    var height = 495;

    if(isMobile){
        height = 220;
    }
    if(isTablet){
        height = 350;
    }

    return (
        <article className="position-relative mt-2 mt-md-0 text-center"
            dangerouslySetInnerHTML={{ __html: `<iframe width="${width}" height="${height}" src='${urlEspecialVideos}/video/${type}/${slug}.html' />` }} 
        />
    )
}

export default Video;

Video.propTypes = {
    slug: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    urlEspecialVideos: PropTypes.string.isRequired
}